import React, { useEffect, useState } from "react";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import Grid from "@mui/material/Grid";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import Select from "@mui/material/Select";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import { yupResolver } from "@hookform/resolvers/yup";
import { useForm, Controller } from "react-hook-form";
import FormHelperText from "@mui/material/FormHelperText";
import * as yup from "yup";
import {
  getShirtType,
  getShirtSize,
  getRactType,
  getRow,
} from "./../../api/master";
import { getSearchEventMember } from "./../../api/event";
import EventStore from "./../../stores/eventStore";

const schema = yup.object({}).required();

const FormSearch = ({ onSubmit, eventId, data }) => {
  const { setMembers } = EventStore();
  const [pDate, setPDate] = useState(null);
  const {
    control,
    handleSubmit,
    formState: { errors },
    setValue,
  } = useForm({
    defaultValues: {
      firstName: "",
      lastName: "",
      sex: "",
      cardId: "",
      ractType: "",
      blushVersion: "",
      bibNumber: "",
      rowNumber: "",
      shirtType: "",
      shirtSize: "",
      pickUp: "",
    },
    resolver: yupResolver(schema),
  });

  /////
  const [shirtType, setShirtType] = useState([]);
  const [shirtSize, setShirtSize] = useState([]);
  const [ractType, setRactType] = useState([]);
  const [row, setRow] = useState([]);

  const loadMasterData = async () => {
    let shirtTypeData = await getShirtType();
    let shirtArr = [];
    if (shirtTypeData.data.data.length > 0) {
      for (let i = 0; i < shirtTypeData.data.data.length; i++) {
        shirtArr.push(shirtTypeData.data.data[i]);
      }
    }
    setShirtType(shirtArr);
    ////////
    let shirtSizeData = await getShirtSize();
    let shirtSizeArr = [];
    if (shirtSizeData.data.data.length > 0) {
      for (let i = 0; i < shirtSizeData.data.data.length; i++) {
        shirtSizeArr.push(shirtSizeData.data.data[i]);
      }
    }
    setShirtSize(shirtSizeArr);
    ////////
    let ractTypeData = await getRactType();
    let ractTypeArr = [];
    if (ractTypeData.data.data.length > 0) {
      for (let i = 0; i < ractTypeData.data.data.length; i++) {
        ractTypeArr.push(ractTypeData.data.data[i]);
      }
    }
    setRactType(ractTypeArr);
    ////////
    let rowData = await getRow();
    let rowArr = [];
    if (rowData.data.data.length > 0) {
      for (let i = 0; i < rowData.data.data.length; i++) {
        rowArr.push(rowData.data.data[i]);
      }
    }
    setRow(rowArr);
  };

  const onSubmitData = async (v) => {
    if (pDate !== null) {
      v.pickUpDate = pDate;
    }
    //alert(JSON.stringify(v));
    //onSubmit(v);
    let data = await getSearchEventMember(eventId, v);
    setMembers(data.data.data);
  };

  useEffect(() => {
    if (data !== null) {
    }
  }, [data]);

  useEffect(() => {
    loadMasterData();
  }, []);

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <form onSubmit={handleSubmit(onSubmitData)} autoComplete="off">
        <Grid container spacing={2}>
          <Grid item xs={12} sm={4}>
            <Controller
              name="firstName"
              control={control}
              render={({ field }) => (
                <TextField
                  margin="normal"
                  fullWidth
                  label="ชื่อ"
                  error={errors.firstName ? true : false}
                  helperText={errors.firstName?.message}
                  {...field}
                />
              )}
            />
          </Grid>
          <Grid item xs={12} sm={4}>
            <Controller
              name="lastName"
              control={control}
              render={({ field }) => (
                <TextField
                  margin="normal"
                  fullWidth
                  label="นามสกุล"
                  error={errors.lastName ? true : false}
                  helperText={errors.lastName?.message}
                  {...field}
                />
              )}
            />
          </Grid>
          <Grid item xs={12} sm={4}>
            <Controller
              name="sex"
              control={control}
              render={({ field: { onChange, onBlur, value } }) => (
                <FormControl sx={{ minWidth: 120 }} margin="normal" fullWidth>
                  <InputLabel>เพศ</InputLabel>
                  <Select
                    value={value}
                    label="เพศ"
                    onChange={onChange}
                    error={errors.sex ? true : false}
                  >
                    <MenuItem value={""}>ทั้งหมด</MenuItem>
                    <MenuItem value={"m"}>ชาย</MenuItem>
                    <MenuItem value={"f"}>หญิง</MenuItem>
                  </Select>
                  <FormHelperText error>{errors.sex?.message}</FormHelperText>
                </FormControl>
              )}
            />
          </Grid>
          <Grid item xs={12} sm={4}>
            <Controller
              name="cardId"
              control={control}
              render={({ field }) => (
                <TextField
                  margin="normal"
                  fullWidth
                  label="หมายเลขบัตรประชาชน"
                  error={errors.cardId ? true : false}
                  helperText={errors.cardId?.message}
                  {...field}
                />
              )}
            />
          </Grid>
          <Grid item xs={12} sm={4}>
            <Controller
              name="bibNumber"
              control={control}
              render={({ field }) => (
                <TextField
                  margin="normal"
                  fullWidth
                  label="BIB"
                  error={errors.bibNumber ? true : false}
                  helperText={errors.bibNumber?.message}
                  {...field}
                />
              )}
            />
          </Grid>
          <Grid item xs={12} sm={4}>
            <Controller
              name="rowNumber"
              control={control}
              render={({ field }) => (
                <TextField
                  margin="normal"
                  fullWidth
                  label="ROW"
                  error={errors.rowNumber ? true : false}
                  helperText={errors.rowNumber?.message}
                  {...field}
                />
              )}
            />
          </Grid>
          <Grid item xs={12} sm={4}>
            <Controller
              name="ractType"
              control={control}
              render={({ field: { onChange, onBlur, value } }) => (
                <FormControl sx={{ minWidth: 120 }} margin="normal" fullWidth>
                  <InputLabel>ประเภทการแข่งขัน</InputLabel>
                  <Select
                    value={value}
                    label="ประเภทการแข่งขัน"
                    onChange={onChange}
                    error={errors.ractType ? true : false}
                  >
                    <MenuItem value={""}>ทั้งหมด</MenuItem>
                    {ractType.map((item, key) => (
                      <MenuItem key={key} value={item.ractTypeId}>
                        {item.ractTypeName}
                      </MenuItem>
                    ))}
                  </Select>
                  <FormHelperText error>
                    {errors.ractType?.message}
                  </FormHelperText>
                </FormControl>
              )}
            />
          </Grid>
          <Grid item xs={12} sm={4}>
            <Controller
              name="blushVersion"
              control={control}
              render={({ field }) => (
                <TextField
                  margin="normal"
                  fullWidth
                  label="รุ่น-อายุ"
                  error={errors.blushVersion ? true : false}
                  helperText={errors.blushVersion?.message}
                  {...field}
                />
              )}
            />
          </Grid>
          <Grid item xs={12} sm={4}>
            <Controller
              name="shirtType"
              control={control}
              render={({ field }) => (
                <TextField
                  margin="normal"
                  fullWidth
                  label="ประเภทเสื้อ"
                  error={errors.shirtType ? true : false}
                  helperText={errors.shirtType?.message}
                  {...field}
                />
              )}
            />
          </Grid>
          <Grid item xs={12} sm={4}>
            <Controller
              name="shirtSize"
              control={control}
              render={({ field }) => (
                <TextField
                  margin="normal"
                  fullWidth
                  label="ขนาดเสื้อ"
                  error={errors.shirtSize ? true : false}
                  helperText={errors.shirtSize?.message}
                  {...field}
                />
              )}
            />
          </Grid>
          <Grid item xs={12} sm={4}>
            <Controller
              name="pickUp"
              control={control}
              render={({ field: { onChange, onBlur, value } }) => (
                <FormControl sx={{ minWidth: 120 }} margin="normal" fullWidth>
                  <InputLabel>สถานะการรับเสื้อ</InputLabel>
                  <Select
                    value={value}
                    label="สถานะการรับเสื้อ"
                    onChange={onChange}
                  >
                    <MenuItem value={""}>ทั้งหมด</MenuItem>
                    <MenuItem value={"N"}>ยังไม่ได้รับ</MenuItem>
                    <MenuItem value={"Y"}>รับแล้ว</MenuItem>
                  </Select>
                </FormControl>
              )}
            />
          </Grid>
          {/*
          <Grid item xs={12} sm={4}>
            <Controller
              name="pickUpDate"
              control={control}
              render={({ field: { onChange, onBlur, value } }) => (
                <DatePicker
                  label="วันที่รับเสื้อ"
                  inputFormat="DD/MM/YYYY"
                  onChange={(v) => setPDate(v)}
                  value={pDate}
                  renderInput={(params) => (
                    <TextField margin="normal" fullWidth {...params} />
                  )}
                />
              )}
            />
          </Grid>
                  */}
          <Grid item xs={12} sm={4}>
            <Button
              type="submit"
              variant="contained"
              size="large"
              style={{ marginTop: 23 }}
            >
              ค้นหา
            </Button>
          </Grid>
        </Grid>
      </form>
    </LocalizationProvider>
  );
};

export default FormSearch;
